import * as React from "react";
import { useState, useContext } from "react";
import { 
  Box, Typography, TextField, Button, 
  CircularProgress, IconButton, InputAdornment, Grid, Stack 
} from "@mui/material";
import { 
  Visibility, 
  VisibilityOff, 
  Speed, 
  PrecisionManufacturingOutlined,
  VerifiedUserOutlined,
  PlayArrow,
  ShieldMoonOutlined,
  SecurityUpdateGoodOutlined,
  SecurityOutlined
} from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthContext } from '../AuthContext.js';
import Appbar from "../Components/Appbar/Appbar";

const THEME_RED = "#ff202b";

function SignInV2() {
  // --- ORIGINAL LOGIC: CONTEXT ---
  const { isAuthenticated, userData, userDetails, setUserDetails, setAuthData, clearAuthData } = useContext(AuthContext);

  const [username, setusername] = useState();
  const [password, setpassword] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // --- ORIGINAL LOGIC: SIGNIN FUNCTION ---
  const signIn = async () => {
    setisLoading(true);
    localStorage.clear();
    if (!username) {
      toast.error("Please Enter Valid Username");
      setisLoading(false); // Added to prevent stuck loading state
    } else if (!password) {
      toast.error("Please Enter Valid Password");
      setisLoading(false); // Added to prevent stuck loading state
    } else {
      axios
        .post("/login", {
          username: username,
          password: password,
        })
        .then((response) => {
          setisLoading(false);
          toast.success("Logged In Successfully!");

          // EXACT STORAGE LOGIC FROM YOUR SNIPPET
          localStorage.setItem("accessToken", response.data.AccessToken);
          localStorage.setItem("roleId", response.data.roleId);
          localStorage.setItem("profileImg", response.data.profileImg);
          localStorage.setItem("username", response.data.username);
          localStorage.setItem("email", response.data.email);
          localStorage.setItem("fullName", response.data.fullName);
          
          const Token = localStorage.getItem('accessToken');
          
          setTimeout(() => {
            // ------ EXPERIMENTAL LOGIN SECURITY (Preserved from your code) -------
            // setUserDetails({
            //   'accessToken':response.data.AccessToken,
            //   'roleId':response.data.roleId,
            //   'profileImg':response.data.profileImg,
            //   'username':response.data.username
            // });
            
            setAuthData(Token);
            navigate("/dashboard");
          }, 2000); // Exact 2s delay

        })
        .catch((err) => {
          setisLoading(false);
          toast.error("Wrong Username or Password");
        });
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      signIn();
    }
  };

  const fieldStyle = {
    mb: 2,
    "& .MuiOutlinedInput-root": {
      color: "#fff",
      borderRadius: "0px",
      backgroundColor: "rgba(255, 255, 255, 0.02)",
      "& fieldset": { 
        borderColor: "rgba(255, 255, 255, 0.1)",
        borderRight: "none", borderTop: "none",
        borderBottom: "1px solid rgba(255,255,255,0.1)"
      },
      "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
      "&.Mui-focused fieldset": { borderColor: THEME_RED, borderBottomWidth: "2px" },
    },
    "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.3)", fontSize: "0.65rem", letterSpacing: 3, textTransform: "uppercase" },
    "& .MuiInputLabel-root.Mui-focused": { color: THEME_RED },
  };

  return (
    <Box sx={{ 
      background: "#050607", 
      backgroundImage: `linear-gradient(rgba(255, 32, 43, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 32, 43, 0.03) 1px, transparent 1px)`,
      backgroundSize: "60px 60px",
      minHeight: "100vh", display: "flex", flexDirection: "column"
    }}>
      <Appbar />

      <Grid container sx={{ flex: 1 }}>
        <Grid item md={6} lg={7} sx={{ display: { xs: "none", md: "flex" }, p: 10, flexDirection: "column", justifyContent: "center" }}>
          <Stack spacing={1}>
            <Typography sx={{ color: THEME_RED, fontWeight: 900, letterSpacing: 8, mb: -1, fontSize: "0.7rem" }}>AUTO ASSIST V2</Typography>
            <Typography variant="h1" sx={{ color: "#fff", fontWeight: 900, fontSize: "5.5rem", lineHeight: 0.9 }}>
              IGNITE<br /><span style={{ color: "rgba(255,255,255,0.05)" }}>SYSTEM</span>
            </Typography>
            <Box sx={{ width: 100, height: 4, bgcolor: THEME_RED, mt: 4 }} />
          </Stack>
        </Grid>

        <Grid item xs={12} md={6} lg={5} sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}>
          <Box sx={{ 
            width: "100%", maxWidth: 450, p: 6, bgcolor: "rgba(10, 11, 13, 0.85)", 
            backdropFilter: "blur(20px)", border: "1px solid rgba(255,255,255,0.05)", position: "relative"
          }}>
            <Stack spacing={4}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <SecurityOutlined sx={{ color: THEME_RED }} />
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.3)", letterSpacing: 2 }}>FLYWHEEL CRM</Typography>
              </Box>

              <Box>
                <TextField
                  fullWidth
                  label="USERNAME"
                  variant="outlined"
                  onChange={(e) => setusername(e.target.value)}
                  onKeyPress={handleKeyPress}
                  sx={fieldStyle}
                />

                <TextField
                  fullWidth
                  label="PASSWORD"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  onChange={(e) => setpassword(e.target.value)}
                  onKeyPress={handleKeyPress}
                  sx={fieldStyle}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} sx={{ color: "rgba(255,255,255,0.2)" }}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>

              <Button
                fullWidth
                onClick={signIn}
                disabled={isLoading}
                sx={{ 
                  height: 65, bgcolor: THEME_RED, color: "#fff", borderRadius: 0, fontWeight: 900, letterSpacing: 4,
                  "&:hover": { bgcolor: "#fff", color: "#000", boxShadow: `0 0 10px ${THEME_RED}44` },
                }}
              >
                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Login"}
              </Button>
            </Stack>
          </Box>
        </Grid>
      </Grid>
      <ToastContainer theme="dark" />
    </Box>
  );
}

export default SignInV2;